var exports = {
  "x6": "AutocompleteItem.module__button___a2Q1MG",
  "kL": "AutocompleteItem.module__container___a2Q1MG",
  "wH": "AutocompleteItem.module__selected___a2Q1MG",
  "Qs": "AutocompleteItem.module__content___a2Q1MG",
  "Kk": "AutocompleteItem.module__icon___a2Q1MG",
  "Bm": "AutocompleteItem.module__nameWrapper___a2Q1MG",
  "UU": "AutocompleteItem.module__name___a2Q1MG",
  "h_": "AutocompleteItem.module__description___a2Q1MG",
};

module.exports = exports;
